import { KeyTextField } from '@prismicio/client';
import { ReactNode } from 'react';
import styles from './statisticsValues.module.scss';

interface StatisticsValuesProps {
  values: KeyTextField[];
  activeItem: number;
}

export const StatisticsValues = ({
  values,
  activeItem,
}: StatisticsValuesProps) => {
  const splitText = (text: string): ReactNode => {
    return text.split('').map(
      (char, index) =>
        char !== ' ' && (
          <span
            key={index}
            className={styles.element}
            style={{
              transitionDuration: `${0.2 + index * 0.1}s`,
              animationDuration: `${0.7 + index * 0.1}s`,
            }}
          >
            {char}
          </span>
        )
    );
  };

  return (
    <div className={styles.wrapper}>
      <ul className={styles.list}>
        {values.map((value, index) => (
          <li
            key={value}
            className={`${styles.item} ${activeItem === index ? styles.visible : styles.hidden}`}
          >
            {splitText(value as string)}
          </li>
        ))}
      </ul>
    </div>
  );
};
